import { useQuery } from 'react-query';
import { queryKeys } from '../../../services/query-key/query-keys';
import { getPrivateApi } from '../../../services/api';
import { CURRENCIES, CurrencyExchangeRatesSchema } from '@vy/types';
import { GetExchangeRatesResponseData } from '../../../../../../libs/client/src/generated/models/GetExchangeRatesResponseData';

export const useExchangeRates = () => {
  return useQuery({
    queryKey: queryKeys.exchangeRates(),
    queryFn: async () => {
      const api = getPrivateApi();
      const response = await api.getExchangeRates();

      const mapExchangeRates = (data: GetExchangeRatesResponseData) => ({
        [CURRENCIES.Usd]: data.uSD,
        [CURRENCIES.Eur]: data.eUR,
        [CURRENCIES.Gbp]: data.gBP,
        [CURRENCIES.Ils]: data.iLS,
        [CURRENCIES.Cad]: data.cAD,
        [CURRENCIES.Aud]: data.aUD,
        [CURRENCIES.Cop]: data.cOP,
        [CURRENCIES.Brl]: data.bRL,
      });

      return CurrencyExchangeRatesSchema.parse(mapExchangeRates(response.data));
    },
  });
};
